<template>
  <ul class="m-progress">
    <a-progress-step
      v-for="(step, index) in progressSteps"
      :key="index"
      :label="step.item.label"
      :state="step.state"
      :sub-step-label="step.item.subStepLabel"
      :steps="step.item.steps"
      :current-step="step.item.currentStep"
      :show-sub-step-number="step.item.showSubStepNumber"
      :highlight-sub-step-current="step.item.highlightSubStepCurrent"
      class="m-progress__item"
      :class="{ 'm-progress__item--expand': step.expand }"
    />
  </ul>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AProgressStep from '@/components/atoms/progress-step/index.vue';

export default {
  name: 'm-progress',
  components: {
    AProgressStep,
  },
  props: {
    steps: {
      type: Array,
      default: null,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    progressSteps() {
      return this.steps.map((item, index) => {
        const step = {
          item,
          state: null,
          expand: false,
        };

        const stepVal = index + 1;
        if (stepVal < this.current) {
          step.state = 'completed';
        } else if (stepVal === this.current) {
          step.state = 'current';
        }

        if (item.steps) {
          step.expand = true;
        }
        return step;
      });
    },
  },
};
</script>
